export enum CredentialStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  INVALID = "INVALID",
}
